// extracted by mini-css-extract-plugin
export default {"wrapper":"Br-z","response":"Cr-z","error":"Dr-z","disabled":"Er-z","buttons":"Fr-z","feedbackQuestionSection":"Gr-z","yesNoWrapper":"Hr-z"};